/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update an existing claim.
 * @export
 * @interface UpdateClaimRequest
 */
export interface UpdateClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    claimNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    insuredPhone?: string | null;
    /**
     * Secondary phone number for the insured
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    insuredPhone2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    insuredEmail?: string | null;
    /**
     * Secondary email address for the insured
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    insuredEmail2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    dateOfLoss?: string | null;
    /**
     * Type of loss (free text)
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    lossType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    propertyAddress?: string | null;
    /**
     * Mailing address if different from property address
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    mailingAddress?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    propertySquareFootage?: number | null;
    /**
     * Insurance company name
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    insuranceCarrier?: string | null;
    /**
     * Internal file number for company tracking
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    internalFileNumber?: string | null;
    /**
     * Name or company of the referring contractor (e.g. the operator who referred this claim).
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    contractor?: string | null;
    /**
     * Update the claim's folder assignment. Set to null to unfile the claim. Optional - if omitted, keeps existing value.
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    claimFolderId?: number | null;
    /**
     * Move the claim to a different pipeline. Switching pipeline resets the claim to that pipeline's first status unless claimStatusTemplateId (belonging to the new pipeline) is also provided. Optional - if omitted, keeps existing pipeline.
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    pipelineId?: number;
    /**
     * Update the claim's status by providing a status template ID. Must belong to the claim's pipeline. Optional - if omitted, keeps existing value.
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    claimStatusTemplateId?: number;
    /**
     * Set true to archive the claim or false to unarchive it.
     * @type {boolean}
     * @memberof UpdateClaimRequest
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UpdateClaimRequest interface.
 */
export function instanceOfUpdateClaimRequest(value: object): value is UpdateClaimRequest {
    return true;
}

export function UpdateClaimRequestFromJSON(json: any): UpdateClaimRequest {
    return UpdateClaimRequestFromJSONTyped(json, false);
}

export function UpdateClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'] == null ? undefined : json['claimNumber'],
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'insuredPhone': json['insuredPhone'] == null ? undefined : json['insuredPhone'],
        'insuredPhone2': json['insuredPhone2'] == null ? undefined : json['insuredPhone2'],
        'insuredEmail': json['insuredEmail'] == null ? undefined : json['insuredEmail'],
        'insuredEmail2': json['insuredEmail2'] == null ? undefined : json['insuredEmail2'],
        'dateOfLoss': json['dateOfLoss'] == null ? undefined : json['dateOfLoss'],
        'lossType': json['lossType'] == null ? undefined : json['lossType'],
        'propertyAddress': json['propertyAddress'] == null ? undefined : json['propertyAddress'],
        'mailingAddress': json['mailingAddress'] == null ? undefined : json['mailingAddress'],
        'propertySquareFootage': json['propertySquareFootage'] == null ? undefined : json['propertySquareFootage'],
        'insuranceCarrier': json['insuranceCarrier'] == null ? undefined : json['insuranceCarrier'],
        'internalFileNumber': json['internalFileNumber'] == null ? undefined : json['internalFileNumber'],
        'contractor': json['contractor'] == null ? undefined : json['contractor'],
        'claimFolderId': json['claimFolderId'] == null ? undefined : json['claimFolderId'],
        'pipelineId': json['pipelineId'] == null ? undefined : json['pipelineId'],
        'claimStatusTemplateId': json['claimStatusTemplateId'] == null ? undefined : json['claimStatusTemplateId'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateClaimRequestToJSON(json: any): UpdateClaimRequest {
    return UpdateClaimRequestToJSONTyped(json, false);
}

export function UpdateClaimRequestToJSONTyped(value?: UpdateClaimRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimNumber': value['claimNumber'],
        'policyNumber': value['policyNumber'],
        'insuredName': value['insuredName'],
        'insuredPhone': value['insuredPhone'],
        'insuredPhone2': value['insuredPhone2'],
        'insuredEmail': value['insuredEmail'],
        'insuredEmail2': value['insuredEmail2'],
        'dateOfLoss': value['dateOfLoss'],
        'lossType': value['lossType'],
        'propertyAddress': value['propertyAddress'],
        'mailingAddress': value['mailingAddress'],
        'propertySquareFootage': value['propertySquareFootage'],
        'insuranceCarrier': value['insuranceCarrier'],
        'internalFileNumber': value['internalFileNumber'],
        'contractor': value['contractor'],
        'claimFolderId': value['claimFolderId'],
        'pipelineId': value['pipelineId'],
        'claimStatusTemplateId': value['claimStatusTemplateId'],
        'isArchived': value['isArchived'],
        'description': value['description'],
    };
}

